import React from 'react';
import PropTypes from 'prop-types';

const ControlPlay = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.19 16.19" {...props}>
    <path
      fill={color}
      d="M15.91 7.64.73.05A.5.5 0 0 0 0 .5v15.18a.5.5 0 0 0 .72.45l15.19-7.59a.5.5 0 0 0 0-.89zM1 14.88V1.31l13.57 6.78z"
    />
  </svg>
);

ControlPlay.propTypes = {
  color: PropTypes.string
};

export default ControlPlay;
